import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import './Hero.css';
import { AuthProvider } from './context/auth';
import Login from './pages/login';
import MenuImpuestoPP from './pages/escritorio';

function App() {

  const pathname = window.location.pathname;

  return (
    <AuthProvider>
      <Router>
        <Route exact path="/" component={Login} />
        {

          pathname !== '/' && (

            <div>
              <MenuImpuestoPP />
            </div>
          )}

      </Router>
    </AuthProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js